var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_17704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C2.4 0 0 1.8 0 6V14.4C0 18.6 2.4 20.4 6 20.4H18C21.6 20.4 24 18.6 24 14.4V6C24 1.8 21.6 0 18 0ZM18.564 7.308L14.808 10.308C14.016 10.944 13.008 11.256 12 11.256C10.992 11.256 9.972 10.944 9.192 10.308L5.436 7.308C5.2524 7.15559 5.13488 6.93807 5.10804 6.70098C5.0812 6.46388 5.14712 6.22559 5.292 6.036C5.604 5.652 6.168 5.58 6.552 5.892L10.308 8.892C11.22 9.624 12.768 9.624 13.68 8.892L17.436 5.892C17.82 5.58 18.396 5.64 18.696 6.036C19.008 6.42 18.948 6.996 18.564 7.308Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_17704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactmail);
export default __webpack_public_path__ + "static/media/contactmail.6f8fe80ea127ef3565e74e5401b1927e.svg";
export { ForwardRef as ReactComponent };